<template>
  <div>
    <div class="row mb-3">
      <div class="col-sm-12 col-md-4 mb-3">
        <validation-provider
          :ref="validationGroup"
          v-slot="{ errors }"
          rules="required"
        >
          <custom-input
            v-model="value.nameFirst"
            :error="errors[0]"
            label="Nombre:"
          />
        </validation-provider>
      </div>
      <div class="col-sm-12 col-md-4 mb-3">
        <validation-provider :ref="validationGroup" v-slot="{ errors }">
          <custom-input
            v-model="value.nameInitial"
            :error="errors[0]"
            label="Inicial:"
            maxlength="1"
          />
        </validation-provider>
      </div>
      <div class="col-sm-12 col-md-4 mb-3">
        <validation-provider
          :ref="validationGroup"
          v-slot="{ errors }"
          rules="required"
        >
          <custom-input
            v-model="value.nameLastPaternal"
            :error="errors[0]"
            label="Apellido Paterno:"
          />
        </validation-provider>
      </div>
      <div class="col-sm-12 col-md-4 mb-3">
        <custom-input
          v-model="value.nameLastMaternal"
          label="Apellido Materno:"
        />
      </div>

      <div class="col-sm-12 col-md-4 mb-3">
        <validation-provider
          :ref="validationGroup"
          v-slot="{ errors }"
          rules="required"
        >
          <custom-input
            v-model="value.workDepartmentName"
            :error="errors[0]"
            label="Departamento:"
          />
        </validation-provider>
      </div>
      <div class="col-sm-12 col-md-4 mb-3">
        <validation-provider
          :ref="validationGroup"
          v-slot="{ errors }"
          rules="required"
        >
          <custom-input
            v-model="value.workPositionTitle"
            :error="errors[0]"
            label="Posición:"
          />
        </validation-provider>
      </div>
      <div class="col-sm-12 col-md-4 mb-3">
        <validation-provider
          :ref="validationGroup"
          v-slot="{ errors }"
          rules="required|email"
        >
          <custom-input
            v-model="value.email"
            :error="errors[0]"
            label="Correo Electrónico:"
          />
        </validation-provider>
      </div>

      <div class="col-sm-12 col-md-4 mb-3">
        <validation-provider
          :ref="validationGroup"
          v-slot="{ errors }"
          name="Celular"
          :rules="isRequiredPhones ? 'required|length:14' : 'length:14'"
        >
          <custom-input
            v-model="value.telephoneMobileNo"
            :custom-error-msg="validationMessages.required"
            :error="errors[0]"
            label="Celular:"
            mask-type="Phone"
            :masked="true"
            placeholder="(___) ___-____"
          />
        </validation-provider>
      </div>
      <div class="col-sm-12 col-md-4 mb-3">
        <div class="col-sm-8 col-lg-8 float-left px-0">
          <validation-provider
            :ref="validationGroup"
            v-slot="{ errors }"
            name="Trabajo"
            :rules="isRequiredPhones ? 'required|length:14' : 'length:14'"
          >
            <custom-input
              v-model="value.telephoneWorkNo"
              :custom-error-msg="validationMessages.required"
              :error="errors[0]"
              label="Trabajo:"
              mask-type="Phone"
              :masked="true"
              placeholder="(___) ___-____"
            />
          </validation-provider>
        </div>
        <div class="col-sm-4 col-lg-4 float-left pl-3 pr-0">
          <custom-input
            v-model="value.telephoneWorkExtNo"
            label="Ext:"
            mask-type="PhoneExt"
            :masked="true"
          />
        </div>
      </div>
      <div class="col-sm-12 col-md-4 mb-3">
        <validation-provider
          :ref="validationGroup"
          v-slot="{ errors }"
          name="Fax"
          :rules="isRequiredPhones ? 'required|length:14' : 'length:14'"
        >
          <custom-input
            v-model="value.telephoneHomeFaxNo"
            :custom-error-msg="validationMessages.required"
            :error="errors[0]"
            label="Fax:"
            mask-type="Phone"
            :masked="true"
            placeholder="(___) ___-____"
          />
        </validation-provider>
      </div>
      <div class="col-sm-12 col-md-4 mb-3">
        <validation-provider
          :ref="validationGroup"
          v-slot="{ errors }"
          name="Hogar"
          :rules="isRequiredPhones ? 'required|length:14' : 'length:14'"
        >
          <custom-input
            v-model="value.telephoneHomeNo"
            :custom-error-msg="validationMessages.required"
            :error="errors[0]"
            label="Hogar:"
            mask-type="Phone"
            :masked="true"
            placeholder="(___) ___-____"
          />
        </validation-provider>
      </div>
      <div class="col-sm-12 col-md-4 mb-3">
        <validation-provider
          :ref="validationGroup"
          v-slot="{ errors }"
          name="EstatusCivil"
          rules="required"
        >
          <custom-drop-down
            v-model="value.civilStatus"
            custom-error-msg="Campo Requerido"
            :error="errors[0]"
            fieldkey="id"
            fieldname="name"
            label="Estatus Civil:"
            :options="civilStatuses"
            placeholder="Seleccione"
          />
        </validation-provider>
      </div>
      <div class="col-sm-12 col-md-4 mb-3">
        <validation-provider
          :ref="validationGroup"
          v-slot="{ errors }"
          name="Municipality"
          rules="required"
        >
          <custom-input
            v-model="value.municipality"
            custom-error-msg="Campo Requerido"
            :error="errors[0]"
            label="Municipio de Residencia:"
          />
        </validation-provider>
      </div>
    </div>
  </div>
</template>

<script>
import CustomInput from '@/components/common/form/CustomInput';
import CustomDropDown from '@/components/common/form/CustomDropDown';

export default {
  name: 'ContactInformation',
  components: {
    CustomInput,
    CustomDropDown,
  },
  props: {
    value: {
      type: Object,
      default: () => ({
        nameInitial: null,
        nameFirst: null,
        workDepartmentName: null,
        telephoneMobileNo: null,
        telephoneHomeNo: null,
        nameLastPaternal: null,
        workPositionTitle: null,
        telephoneWorkNo: null,
        nameLastMaternal: null,
        email: null,
        telephoneHomeFaxNo: null,
        isPrimary: false,
        signMonthlyCertifications: false,
        civilStatus: null,
        municipality: null,
      }),
    },
    civilStatuses: {
      type: Array,
      default: () => [],
    },
    validationGroup: {
      type: String,
      default: 'vgContactInformation',
    },
  },
  data() {
    return {
      validationMessages: {
        required: 'Campo Requerido',
        emailnotvalid: 'Correo Electrónico inválido',
      },
    };
  },
  computed: {
    isRequiredPhones() {
      return (
        (this.value.telephoneMobileNo == null ||
          this.value.telephoneMobileNo == '') &&
        (this.value.telephoneWorkNo == null ||
          this.value.telephoneWorkNo == '') &&
        (this.value.telephoneHomeFaxNo == null ||
          this.value.telephoneHomeFaxNo == '') &&
        (this.value.telephoneHomeNo == null || this.value.telephoneHomeNo == '')
      );
    },
  },
  watch: {
    'value.municipality': function(newValue) {
      if (newValue) {
        // Filtra números y caracteres especiales, permite solo letras y espacios
        const filtered = newValue.replace(/[^a-zA-ZáéíóúÁÉÍÓÚñÑüÜ\s]/g, '');
        if (filtered !== newValue) {
          this.$nextTick(() => {
            this.value.municipality = filtered;
          });
        }
      }
    },
  },
  mounted() {
    this.setMaskedPhoneNumbers();
  },
  methods: {
    setMaskedPhoneNumbers() {
      this.value.telephoneMobileNo = this.formatPhoneNumber(
        this.value.telephoneMobileNo
      );
      this.value.telephoneWorkNo = this.formatPhoneNumber(
        this.value.telephoneWorkNo
      );
      this.value.telephoneWorkExtNo = this.formatPhoneNumber(
        this.value.telephoneWorkExtNo
      );
      this.value.telephoneHomeFaxNo = this.formatPhoneNumber(
        this.value.telephoneHomeFaxNo
      );
      this.value.telephoneHomeNo = this.formatPhoneNumber(
        this.value.telephoneHomeNo
      );
    },
    formatPhoneNumber(phoneNumberString) {
      var cleaned = ('' + phoneNumberString).replace(/\D/g, '');
      var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
      if (!match) return null;
      return '(' + match[1] + ') ' + match[2] + '-' + match[3];
    },
  },
};
</script>
